import React from 'react';

const Pkgs: React.FC<any> = function (props) {
  return props.children || null;
};

export default Pkgs;
